"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const Option_1 = require("./Option");
const execution_1 = require("../execution");
const cloudProvider_1 = __importDefault(require("../types/cloudProvider"));
const NodeTypeMapper_1 = require("../nodes/NodeTypeMapper");
const extendedTypes_1 = require("../types/extendedTypes");
exports.getWorkflowModelParamsFromTemplate = params => {
  if (!params || !params.template || !params.template.definition) return null;
  let { template, user } = params;
  let { categories, properties } = template;
  let props = {
    isModelDirty: true,
    user,
    definition: template.definition,
    name: template.name,
    properties: {
      linkedTemplates: properties.linkedTemplates || [],
      templateId: template.id,
      categories,
      active: false,
      queueable: properties.queueable || false,
      priority: properties.priority || 1,
      severity: properties.severity || 1 // LOW
    }
  };
  return props;
};
class Workflow {
  constructor(props) {
    this.validateOptions = () => {
      let credential = this.getCredentials();
      let region = this.getRegion();
      let nodes = this.getNodes();
      const [
        awsNodeIsPresent,
        azureNodeIsPresent,
        vmwareNodeIsPresent,
        k8NodeIsPresent,
        tfNodeIsPresent,
        gcpNodeIsPresent
      ] = [
        cloudProvider_1.default.AWS,
        cloudProvider_1.default.AZURE,
        cloudProvider_1.default.VMWARE,
        cloudProvider_1.default.Kubernetes,
        cloudProvider_1.default.TerraformCloud,
        cloudProvider_1.default.GCP
      ].map(cp => nodes.find(node => node.getCloudProvider() === cp));
      let resourceGroup = this.getCredentials(
        types_1.CredentialVariables.resourceGroup
      );
      let credentials_azure = this.getCredentials(
        types_1.CredentialVariables.credentials_azure
      );
      let credentials_vmware = this.getCredentials(
        types_1.CredentialVariables.credentials_vmware
      );
      let cred_k8 = this.getCredentials(
        types_1.CredentialVariables.credentials_k8
      );
      let cred_tfc = this.getCredentials(
        types_1.CredentialVariables.credentials_tfc
      );
      // GCP credentials
      let cred_gcp = this.getCredentials(
        types_1.CredentialVariables.credentials_gcp
      );
      // GCP project
      let cred_project = this.getCredentials(
        types_1.CredentialVariables.project
      );
      if (awsNodeIsPresent) {
        if (!credential)
          return types_1.getInvalidResponse("Please select a  AWS Account");
        if (!region)
          return types_1.getInvalidResponse("Please select a Region");
      }
      if (azureNodeIsPresent) {
        if (!credentials_azure) {
          return types_1.getInvalidResponse("Please select a Azure Account");
        }
        if (!resourceGroup) {
          return types_1.getInvalidResponse("Please select a Resource Group");
        }
      }
      //Check if no region is selected when there is no aws node
      if (vmwareNodeIsPresent && !credentials_vmware) {
        return types_1.getInvalidResponse("Please select a VMWARE Account");
      }
      if (k8NodeIsPresent && !cred_k8) {
        return types_1.getInvalidResponse("Please select a K8 Account");
      }
      if (tfNodeIsPresent && !cred_tfc) {
        return types_1.getInvalidResponse(
          "Please select a Terraform cloud Account"
        );
      }
      if (gcpNodeIsPresent) {
        // TODO - Change message once we have cre
        if (!cred_gcp)
          return types_1.getInvalidResponse(
            "Please add GCP credentials to workflow variables"
          );
      }
      return types_1.getValidResponse();
    };
    this.validateConnections = wfValidationOptions => {
      if (this.getNodes().length <= 1)
        return types_1.getInvalidResponse(
          "Invalid number of nodes: " + this.getNodes().length
        );
      let nodes = this.getNodes();
      if (
        !wfValidationOptions ||
        !wfValidationOptions.skipTriggerNodeRequirement
      ) {
        if (nodes[0].getNodeId() !== "trigger")
          return types_1.getInvalidResponse(
            "Invalid trigger node id. Should be => 'trigger'"
          );
        if (nodes[0].getPrevious())
          return types_1.getInvalidResponse(
            "Invalid previous id for trigger node"
          );
      }
      for (let i = 0; i < nodes.length; i++) {
        if (
          i !== nodes.length - 1 &&
          nodes[i].getNext() !== nodes[i + 1].getNodeId()
        ) {
          return types_1.getInvalidResponse(
            "Invalid next pointer: " +
              nodes[i].getNext() +
              " for node:" +
              nodes[i].getNodeId()
          );
        }
        if (i !== 0 && nodes[i].getPrevious() !== nodes[i - 1].getNodeId()) {
          return types_1.getInvalidResponse(
            "Invalid previous pointer: " +
              nodes[i].getPrevious() +
              " for node:" +
              nodes[i].getNodeId()
          );
        }
      }
      return types_1.getValidResponse();
    };
    this.setWorkflowName = value => {
      this.name = value;
      this.markAsModified();
    };
    this.isDirty = () => this.isModified;
    this.toggleActive = () => {
      // should not restrict here.. restricting in ui.
      // if (!this.id) return; // no toggling if workflow is not saved.
      this.properties.active = !this.isActive();
      this.markAsModified();
    };
    this.markAsClean = () => {
      this.isModified = false;
      for (const updateListener of this.updateListeners) {
        updateListener();
      }
    };
    this.forceUpdateListeners = () => {
      this.triggerUpdateListeners();
    };
    this.markAsModified = () => {
      this.isModified = true;
      this.triggerUpdateListeners();
    };
    this.triggerUpdateListeners = () => {
      for (const updateListener of this.updateListeners) {
        updateListener();
      }
    };
    this.addUpdateListener = listener => {
      // console.log('adding update listener');
      this.updateListeners.push(listener);
    };
    this.removeUpdateListener = listener => {
      let index = this.updateListeners.indexOf(listener);
      if (index !== -1) {
        this.updateListeners.splice(index, 1);
      }
    };
    this.removeAllListeners = () => {
      this.updateListeners = [];
    };
    /**
     *  Add and Option to Workflow if the option key is not present
     */
    this.addOption = option => {
      const exists = this.definition.variables.find(
        x => x.getKey() === option.getKey()
      );
      if (exists) return;
      this.definition.variables.push(option);
    };
    if (!props.user) throw new Error("User is required to create a workflow");
    this.user = props.user;
    this.isModified = props.isModelDirty;
    this.id = props.workflow;
    this.name = props.name;
    this.dataResolver = props.dataResolver || null;
    this.definition = { components: [], variables: [] };
    this.updateListeners = [];
    this.restoreProperties(props);
    this.restoreNodes(props);
    this.restoreOptions(props);
    // todo validate workflow
    this.execution = null;
    this.callReloadApi = props.callReloadApi;
    if (props.group) {
      this.group = props.group;
    }
  }
  restoreProperties(props) {
    this.properties = props.properties || { active: false };
    if (!this.properties.hasOwnProperty("priority")) {
      this.properties.priority = 1;
    }
    if (!this.properties.hasOwnProperty("severity")) {
      this.properties.severity = types_1.SEVERITY.LOW;
    }
    if (!this.properties.hasOwnProperty("categories")) {
      this.properties.categories = [{ category: "Custom", subCategories: [] }];
    }
  }
  isCredentialKey(key) {
    return (
      key === types_1.CredentialVariables.credentials ||
      key === types_1.CredentialVariables.credentials_vmware ||
      key === types_1.CredentialVariables.credentials_azure ||
      key === types_1.CredentialVariables.credentials_k8 ||
      key === types_1.CredentialVariables.credentials_tfc
    );
  }
  removeCredentials() {
    this.definition.variables = this.definition.variables.filter(
      x => !this.isCredentialKey(x.getKey())
    );
  }
  removeOption(key) {
    this.definition.variables = this.definition.variables.filter(
      x => x.getKey() !== key
    );
  }
  addOptions(variables) {
    let credentials = this.getOptions().filter(
      option =>
        option.getKey() == types_1.CredentialVariables.credentials ||
        option.getKey() === types_1.CredentialVariables.credentials_azure ||
        option.getKey() === types_1.CredentialVariables.credentials_vmware ||
        option.getKey() === types_1.CredentialVariables.credentials_k8 ||
        option.getKey() === types_1.CredentialVariables.credentials_tfc
    );
    if (!variables) variables = [];
    variables = variables.filter(
      (x, i, a) => a.findIndex(v => v.key === x.key) === i
    );
    this.setWorkflowOptions(variables.map(x => new Option_1.Option(x)));
    // setting credentials as it wont be a part of param variables.
    credentials.forEach(cred => {
      this.setCredentials(cred.getValue().replace(/^@/, ""), cred.getKey());
    });
  }
  getSerializedOptions() {
    return this.getOptions().map(x => ({
      key: x.getKey(),
      value: x.getValue()
    }));
  }
  getOptions() {
    return this.definition.variables;
  }
  restoreOptions(props) {
    let definition = props.definition;
    if (!definition) return;
    let parsedDef = JSON.parse(definition);
    if (!parsedDef.variables || !parsedDef.variables.length) return;
    let variables = parsedDef.variables;
    this.setWorkflowOptions(variables.map(x => new Option_1.Option(x)));
  }
  hasCloudNode(provider) {
    return Boolean(
      this.getNodes().find(node => node.getCloudProvider() === provider)
    );
  }
  getNodesValidationResponse(labels) {
    if (labels.length === 1) {
      return types_1.getInvalidResponse(labels[0] + " node has invalid data");
    } else if (labels.length > 0) {
      let nodesLabels = labels.join(", ");
      let message =
        nodesLabels.substring(0, nodesLabels.lastIndexOf(", ")) +
        " and " +
        nodesLabels.substring(nodesLabels.lastIndexOf(", ") + 2) +
        " node has invalid data";
      return types_1.getInvalidResponse(message);
    }
    return types_1.getValidResponse();
  }
  /**
   * check if credentials and region is present in variables
   * check if all next and previous pointer are correct
   * checks if all node data is valid.
   * return ValidationResponseType = {message:string, isValid:boolean}
   */
  validate(validationOptions) {
    if (
      !(validationOptions && validationOptions.skipNameValidation) &&
      !this.name
    )
      return types_1.getInvalidResponse("Please enter workflow name");
    if (
      !(validationOptions && validationOptions.skipCredsAndRegionValidation)
    ) {
      let optionsValidation = this.validateOptions();
      if (!optionsValidation.isValid) return optionsValidation;
    }
    let connectionsValidation = this.validateConnections();
    if (!connectionsValidation.isValid) return connectionsValidation;
    let invalidNodes = [];
    for (let node of this.getNodes()) {
      let isValid = node.validate();
      // console.log(isValid, node.getNodeLabel());
      if (!isValid) invalidNodes.push(node.getNodeLabel());
    }
    return this.getNodesValidationResponse(invalidNodes);
  }
  getNewCategories() {
    let region = this.getRegion();
    let resourceGroup = this.getCredentials(
      types_1.CredentialVariables.resourceGroup
    );
    let account = [
      this.getCredentials(types_1.CredentialVariables.credentials),
      this.getCredentials(types_1.CredentialVariables.credentials_azure),
      this.getCredentials(types_1.CredentialVariables.credentials_vmware),
      this.getCredentials(types_1.CredentialVariables.credentials_k8),
      this.getCredentials(types_1.CredentialVariables.credentials_tfc)
    ].filter(x => x);
    return [
      {
        category: "Account",
        subCategories: account.length > 0 ? account : []
      },
      {
        category: "Region",
        subCategories: this.hasCloudNode(cloudProvider_1.default.AWS)
          ? [region]
          : ["*"]
      },
      {
        category: "ResourceGroup",
        subCategories: this.hasCloudNode(cloudProvider_1.default.AZURE)
          ? [resourceGroup]
          : ["*"]
      }
    ];
  }
  updateProperties() {
    let newCategories = this.getNewCategories();
    let categories = this.properties.categories || newCategories;
    ["Account", "Region", "ResourceGroup"].forEach(key => {
      let existingIndex = categories.findIndex(x => x.category === key);
      let newIndex = newCategories.findIndex(x => x.category === key);
      if (existingIndex === -1) {
        categories.push(newCategories[newIndex]);
      } else {
        categories[existingIndex] = newCategories[newIndex];
      }
    });
    this.properties.categories = categories;
    return this.properties;
  }
  serialize(validationOptions) {
    if (!validationOptions || !validationOptions.skipFullValidation) {
      let validationResult = this.validate(validationOptions);
      if (!validationResult.isValid) throw new Error(validationResult.message);
    }
    let serializedOptions = this.getSerializedOptions();
    return {
      user: this.user,
      definition: {
        variables: serializedOptions,
        components: this.definition.components.map(x => x.serializeNode())
      },
      workflow: this.id,
      name: this.name || "",
      properties: this.updateProperties(),
      group: this.group
    };
  }
  getNewNodeName(node) {
    let type = node.getNodeLabel();
    let nodes = this.getNodesByType(node.getNodeType());
    if (!nodes.length) return type;
    else return `${type} (${nodes.length + 1})`;
  }
  // add enrichment node
  restoreNodes(props) {
    let definition = props.definition;
    if (!definition) return;
    definition = definition.replace(/:user/g, props.user);
    let parsedDef = JSON.parse(definition);
    if (!parsedDef.components || !parsedDef.components.length) return;
    for (let comp of parsedDef.components) {
      let type = comp.type;
      let userDefinedNodeId = comp.userDefinedNodeId;
      if (userDefinedNodeId) {
        type = extendedTypes_1.getUserDefinedNodeType(type, userDefinedNodeId);
      }
      if (!NodeTypeMapper_1.nodeTypeMapper.hasOwnProperty(type)) {
        throw new Error("Node not implemented " + type);
      }
      let node = new NodeTypeMapper_1.nodeTypeMapper[type](comp);
      node.setNodeName(this.getNewNodeName(node));
      node.setNodeDescription(comp.description);
      if (comp.selectedResource) {
        let selectedResource = comp.selectedResource;
        let selectedNode = this.getNodeById(
          comp.selectedResource.selectedResourceId
        );
        selectedResource.nodeRef = selectedNode;
        if (
          selectedNode &&
          selectedResource.label.indexOf(selectedNode.getNodeId()) !== -1
        ) {
          selectedResource.label = selectedResource.label.replace(
            selectedNode.getNodeId(),
            selectedNode.getNodeName
          );
        }
        node.setSelectedResource(selectedResource);
      }
      node.setDataResolver(this.dataResolver);
      this.definition.components.push(node);
    }
  }
  getUser() {
    return this.user;
  }
  getNodesByType(type) {
    return this.definition.components.filter(x => x.getNodeType() === type);
  }
  getNodes() {
    return this.definition.components;
  }
  getNodeIndex(nodeId) {
    return this.getNodes().findIndex(x => x.getNodeId() === nodeId);
  }
  getWorkflowName() {
    return this.name || "";
  }
  getWorkflowDescription() {
    return this.properties.description || "";
  }
  getNodeById(nodeId) {
    return this.getNodes().find(item => item.getNodeId() === nodeId);
  }
  getId() {
    return this.id || "";
  }
  getCredentials(key = types_1.CredentialVariables.credentials) {
    let credentials = this.getOptions().filter(opt => opt.getKey() === key)[0];
    if (!credentials) return undefined;
    const value = credentials.getValue();
    if (typeof value === "string") return value.replace(/^@/, "");
    return value;
  }
  isActive() {
    return this.properties.active;
  }
  getRegion() {
    let regionOption = this.getOptions().filter(
      opt => opt.getKey() === "region"
    )[0];
    return regionOption && regionOption.getValue();
  }
  async getAllOutputKeys(selectedNodeId) {
    let nodes = this.getNodes();
    let lastIndex = nodes.length - 1;
    if (selectedNodeId) {
      lastIndex = nodes.findIndex(x => x.getNodeId() === selectedNodeId);
    }
    nodes = nodes.filter((x, i) => i <= lastIndex);
    if (!nodes || nodes.length === 0) return {};
    let outputSchema = {};
    for (let node of nodes) {
      let availableOptions = (await node.getAvailableResources()).filter(
        x => !x.path
      );
      outputSchema[node.getNodeId()] = await Promise.all(
        availableOptions.map(x => {
          return this.getOutputKeysOfSelectedResource(x);
        })
      ).then(outputKeysOfAvailableOptions => {
        let res = {};
        for (let i = 0; i < outputKeysOfAvailableOptions.length; i++) {
          let key = availableOptions[i].label.substring(
            availableOptions[i].label.lastIndexOf(".") + 1
          );
          res[key] = outputKeysOfAvailableOptions[i].map(x =>
            x.value.replace(/\.\./g, ".")
          );
        }
        return res;
      });
    }
    return outputSchema;
  }
  /**
   * get all resource previous to given node.
   * @param node
   */
  async getAllAvailableResources(node) {
    let allResources = [];
    if (node.getNodeType() !== types_1.NODE_TYPES.FILTER)
      allResources.push({
        label: "NONE",
        selectedResourceId: "NONE",
        path: "",
        nodeRef: null,
        context: {
          outputPath: ""
        }
      });
    let previous = node.getPrevious();
    if (!previous) return [];
    while (previous) {
      let previousNode = this.getNodeById(previous);
      let avRes = await previousNode.getAvailableResources();
      allResources = allResources.concat(avRes);
      previous = previousNode.getPrevious();
    }
    // dont show trigger node as selected resource for resource scheduling
    if (this.group)
      return allResources.filter(x => x.selectedResourceId !== "trigger");
    return allResources;
  }
  async getOutputKeysOfSelectedResource(selectedResource) {
    if (!selectedResource) return [];
    if (selectedResource.label === "NONE") return [];
    let node = this.getNodeById(selectedResource.selectedResourceId);
    return node.getOutputKeys({ resource: selectedResource, workflow: this });
  }
  setWorkflowOptions(options) {
    this.definition.variables = options;
    this.markAsModified();
  }
  addNodeBefore(node, id) {
    if (!id) throw new Error("Invalid node id");
    let nodeName = this.getNewNodeName(node);
    node.setNodeName(nodeName);
    let nextNode = this.getNodeById(id);
    let nextNodeIndex = this.getNodeIndex(id);
    if (!nextNode) throw new Error("Node with given id not exists");
    let previousPointer = nextNode.getPrevious();
    if (!previousPointer)
      throw new Error("Can not add node before initial node");
    let previousNode = this.getNodeById(previousPointer);
    node.setPrevious(previousPointer);
    node.setNext(id);
    node.setDataResolver(this.dataResolver);
    nextNode.setPrevious(node.getNodeId());
    previousNode.setNext(node.getNodeId());
    this.getNodes().splice(nextNodeIndex, 0, node);
    this.markAsModified();
  }
  addNodeAtLast(node) {
    let nodeName = this.getNewNodeName(node);
    node.setNodeName(nodeName);
    let length = this.getNodes().length;
    if (length !== 0) {
      let lastNode = this.getNodes()[length - 1];
      lastNode.setNext(node.getNodeId());
      node.setPrevious(lastNode.getNodeId());
    }
    node.setDataResolver(this.dataResolver);
    this.getNodes().push(node);
    this.markAsModified();
  }
  getNodeWithSelectedResourceId(nodeId) {
    return this.getNodes().filter(x => {
      let selectedResource = x.getSelectedResource();
      if (!selectedResource) return false;
      return selectedResource.selectedResourceId == nodeId;
    });
  }
  removeSelectedNodeRef(nodeId) {
    let nodesWithSelectedResource = this.getNodeWithSelectedResourceId(nodeId);
    if (nodesWithSelectedResource.length === 0) return;
    for (let node of nodesWithSelectedResource) {
      node.setSelectedResource(null);
    }
    this.markAsModified();
  }
  removeNode(id) {
    // todo change the pointers
    if (!id) throw new Error("Invalid node id");
    const node = this.getNodeById(id);
    if (!node) throw new Error("Node with given id doesn't exists");
    let previousNodeId = node.getPrevious();
    if (!previousNodeId) throw new Error("Can't delete 1st node");
    let prevNode = this.getNodeById(previousNodeId);
    if (!prevNode) throw new Error("Node with given id doesn't exists");
    prevNode.setNext(null);
    let nextNodeId = node.getNext();
    if (nextNodeId) {
      let nextNode = this.getNodeById(nextNodeId);
      nextNode.setPrevious(previousNodeId);
      prevNode.setNext(nextNodeId);
    }
    this.removeSelectedNodeRef(id);
    this.getNodes().splice(this.getNodeIndex(id), 1);
    this.markAsModified();
  }
  setId(value) {
    this.id = value;
    this.markAsModified();
  }
  setCredentials(value, key = types_1.CredentialVariables.credentials) {
    let currentCredsOption = this.getOptions().filter(
      opt => opt.getKey() === key
    )[0];
    if (!currentCredsOption) {
      this.getOptions().push(
        new Option_1.Option({ key: key, value: `@${value}` })
      );
    } else {
      currentCredsOption.setValue(`@${value}`);
    }
    this.markAsModified();
  }
  setRegion(value) {
    let currentRegionOption = this.getOptions().filter(
      opt => opt.getKey() === "region"
    )[0];
    if (!currentRegionOption) {
      this.getOptions().push(new Option_1.Option({ key: "region", value }));
    } else {
      currentRegionOption.setValue(value);
    }
    this.markAsModified();
  }
  createNode(type) {
    if (!NodeTypeMapper_1.nodeTypeMapper.hasOwnProperty(type)) {
      throw new Error("Node not implemented " + type);
    }
    return new NodeTypeMapper_1.nodeTypeMapper[type]();
  }
  getDefinition() {
    return this.definition;
  }
  getProperties() {
    return this.properties;
  }
  async setAssociatedExecution(workflow, execution, copyUntil) {
    let stepsIds = [];
    if (copyUntil) {
      let nodes = this.getNodes();
      let copyIndex = nodes.findIndex(n => n.getNodeId() === copyUntil);
      stepsIds = nodes.slice(0, copyIndex + 1).map(n => n.getNodeId());
    } else {
      stepsIds = this.getNodes().map(n => n.getNodeId());
    }
    let internalSteps = [];
    const userDefinedNodes = this.getNodesByType(
      types_1.NODE_TYPES.UserDefinedNode
    )
      .map(n => n.getNodeDefinition())
      .filter(node => !!node);
    const nodesWithTemplates = userDefinedNodes.filter(
      x => x.type === "template"
    );
    for (const temp of nodesWithTemplates) {
      const templateId = temp.templateLocation && temp.templateLocation.id;
      let templateData = null;
      if (this.dataResolver)
        templateData = await this.dataResolver.resolve(
          "getTemplate",
          templateId,
          error => {}
        );
      if (templateData) {
        const { definition } = templateData;
        const { components } =
          typeof definition === "string" ? JSON.parse(definition) : definition;
        const ids = components.map(com => com.id).filter(id => Boolean(id));
        internalSteps = internalSteps.concat(ids);
      }
    }
    stepsIds = stepsIds.concat(internalSteps);
    this.execution = new execution_1.Execution(workflow, execution, stepsIds);
    this.triggerUpdateListeners();
    this.execution.setUpdateListener(this.triggerUpdateListeners);
    return this.execution;
  }
  getAssociatedExecution() {
    return this.execution;
  }
  setGroup(s) {
    this.group = s;
  }
  getGroup() {
    return this.group;
  }
  getPriority() {
    return this.properties.priority || 1;
  }
  getSeverity() {
    return this.properties.severity || types_1.SEVERITY.LOW;
  }
  modifyPriority(priority) {
    this.properties.priority = priority;
  }
  modifySeverity(severity) {
    this.properties.severity = severity;
  }
  getCategories() {
    let categories = this.properties.categories || [];
    return categories.filter(
      x => x.category !== "Account" && x.category !== "Region"
    );
  }
  updateCategories(categories) {
    this.properties.categories = categories;
  }
}
exports.Workflow = Workflow;
//# sourceMappingURL=index.js.map
